import { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import authService from '@/services/authService';
import { AdminUser } from '@/types/auth';

const { Content } = Layout;

const AdminLayout = () => {
  const [adminUser, setAdminUser] = useState<AdminUser | null>(null);
  const collapsed = false;

  useEffect(() => {
    const loadAdminUser = async () => {
      try {
        const response = await authService.verifyAdmin();
        if (response.success && response.adminUser) {
          setAdminUser(response.adminUser);
        }
      } catch (error) {
        console.error('Failed to load admin user:', error);
      }
    };

    loadAdminUser();
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Layout className="min-h-screen">
      <Sidebar 
        collapsed={collapsed} 
        adminUser={adminUser}
        onLogout={handleLogout}
      />
      <Layout className={`transition-all duration-200 ${collapsed ? 'ml-20' : 'ml-64'}`} style={{ marginLeft: collapsed ? 80 : 256 }}>
        <Content className="m-6 p-6 min-h-screen">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
